import * as React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

import * as PermissionsHelper from '../../helpers/permissionsHelper';
import { PageTitle } from '../pages/pageTitle';

import CopyClipTemplateConfigFromClient from './copyClipTemplateConfigFromClientForm';
import NewClientForm from './newClientForm';
import { ActiveClientsTableContainer } from './clientsTableActiveContainer';
import { ArchivedClientsTableContainer } from './clientsTableArchivedContainer';

// eslint-disable-next-line react/prefer-stateless-function
export class ClientsPage extends React.Component {
  public render() {
    return (
      <>
        <PageTitle displayTitle="Clients">
          {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.CreateClient) && <NewClientForm />}
        </PageTitle>
        {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.GetClients) && (
          <Tabs>
            <TabList>
              <Tab>Active clients</Tab>
              <Tab>Archived clients</Tab>
            </TabList>
            <TabPanel>
              <ActiveClientsTableContainer />
            </TabPanel>
            <TabPanel>
              <ArchivedClientsTableContainer />
            </TabPanel>
          </Tabs>
        )}
        <CopyClipTemplateConfigFromClient />
      </>
    );
  }
}
